import 'css-chunksrc/client/common/loader/styles.scss';export default {
  "loader": "_loader_42l5w_1"
};